import { render, staticRenderFns } from "./PhotoCard.vue?vue&type=template&id=217235d7&"
import script from "./PhotoCard.vue?vue&type=script&lang=ts&"
export * from "./PhotoCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports